import { useState, useEffect } from "react";
import "./AnimatedDP3D.css";

// variant: "navbar" (small, dark-mode purple) | "hero" (large, white on gradient)
// letters: "DP" | "D" | "P"
export function AnimatedDP3D({ variant = "navbar", letters = "DP" }) {
  const [phase, setPhase] = useState("entering");

  useEffect(() => {
    const t = setTimeout(() => setPhase("settled"), 2200);
    return () => clearTimeout(t);
  }, []);

  const showD = letters.includes("D");
  const showP = letters.includes("P");

  return (
    <div
      className={`dp3d dp3d--${phase} dp3d--${variant} dp3d--letters-${letters.toLowerCase()}`}
      aria-label={letters}
    >
      {showD && <span className="dp3d__letter dp3d__d">D</span>}
      {showP && <span className="dp3d__letter dp3d__p">P</span>}
    </div>
  );
}
